import type { LanguageMode } from "../doc/languageMode.js";

/** Map app language mode to Monaco language id (fallback `plaintext`). */
export function monacoLanguageId(mode: LanguageMode): string {
  switch (mode) {
    case "text":
      return "plaintext";
    case "js":
      return "javascript";
    case "ts":
      return "typescript";
    case "json":
      return "json";
    case "html":
      return "html";
    case "xml":
      return "xml";
    case "css":
      return "css";
    case "md":
      return "markdown";
    case "tex":
    case "max":
    case "oeis":
      return "plaintext";
    case "python":
      return "python";
    case "java":
      return "java";
    case "cpp":
    case "c":
      return "cpp";
    case "cs":
      return "csharp";
    case "php":
      return "php";
    case "sql":
      return "sql";
    case "bash":
      return "shell";
    case "powershell":
      return "powershell";
    case "ruby":
      return "ruby";
    case "go":
      return "go";
    case "rust":
      return "rust";
    case "r":
      return "r";
    case "lua":
      return "lua";
    case "perl":
      return "perl";
    case "yaml":
      return "yaml";
    case "ini":
      return "ini";
    case "makefile":
    case "props":
    case "csv":
    case "excel":
    case "pdf":
    case "diff":
    case "linuxobj":
      return "plaintext";
    default:
      return "plaintext";
  }
}
